import { render, staticRenderFns } from "./PartyBuilding.vue?vue&type=template&id=2c70d977&scoped=true&"
import script from "./PartyBuilding.vue?vue&type=script&lang=js&"
export * from "./PartyBuilding.vue?vue&type=script&lang=js&"
import style0 from "./PartyBuilding.vue?vue&type=style&index=0&id=2c70d977&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70d977",
  null
  
)

export default component.exports